<template>
    <div class="d-flex justify-content-center mb-3">
        <b-spinner label="Loading..."></b-spinner>
        <!--<button v-if="updateExists" @click="refreshApp">
            New version available! Click to update
        </button>-->
    </div>
</template>

<script>
    export default {
        name: "loading",
        props: {},
        components: {},
        data() {
            return {
                refreshing: false,
                registration: null,
                updateExists: false,
            };
        },
        created() {
            document.addEventListener(
                'swUpdated', this.showRefreshUI, { once: true }
            );
            navigator.serviceWorker.addEventListener(
                'controllerchange', () => {
                    if (this.refreshing) return;
                    this.refreshing = true;
                    window.location.reload();
                }
            );
        },
        methods:
        {
            refreshApp() {
                this.updateExists = false;
                //if (!this.registration || !this.registration.waiting) { return; }
                this.registration.waiting.postMessage('skipWaiting');
            },
            showRefreshUI(e) {
                this.registration = e.detail;
                this.updateExists = true;
            },
        }
    };
</script>
